import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import NtTouchableEffect from "./NtTouchableEffect";
import { useTheme } from "../context/ThemeContext";

/**
 * Card container. Theme-driven — default surface is the "surface2" token
 * (nested card on the main-card background). Pass `style` to override.
 *
 *   <NtCard><NtText>...</NtText></NtCard>
 *   <NtCard onPress={...} style={{ padding: 16 }}>...</NtCard>
 */
function NtCard({ children, style, containerStyle, onPress = null }) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  return (
    <View style={[styles.container, style]}>
      <NtTouchableEffect style={containerStyle} onPress={onPress}>
        {children}
      </NtTouchableEffect>
    </View>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    container: {
      backgroundColor: t.surface2,
      borderWidth: 1,
      borderColor: t.borderSoft,
      borderRadius: t.radius,
      padding: 10,
      marginLeft: 4,
      marginRight: 4,
    },
  });

export default NtCard;
